// assets/quantity-input.js
;(() => {
  function clampValue(input) {
    const container = input.closest('[data-qty]')
    const min = input.min ? +input.min : 1
    const max = container?.dataset.max
      ? +container.dataset.max
      : input.max
        ? +input.max
        : 999
    const val = +input.value || min
    return Math.max(min, Math.min(max, val))
  }

  function sync(container, emit = false) {
    const input = container.querySelector('input[type="number"]')
    if (!input) return

    const step = parseFloat(container?.dataset.step || input.step || '1') || 1
    input.step = step

    const v = clampValue(input)
    const min = input.min ? +input.min : 1
    const max = container?.dataset.max
      ? +container.dataset.max
      : input.max
        ? +input.max
        : 999

    let status = container.querySelector('[data-qty-status]')
    if (!status) {
      status = document.createElement('span')
      status.dataset.qtyStatus = ''
      status.className = 'sr-only'
      status.setAttribute('aria-live', 'polite')
      container.appendChild(status)
    }

    if (max === 0) {
      input.value = 0
      input.setAttribute('disabled', 'disabled')
      container
        .querySelector('[data-qty-minus]')
        ?.setAttribute('disabled', 'disabled')
      container
        .querySelector('[data-qty-plus]')
        ?.setAttribute('disabled', 'disabled')
      status.textContent = 'Out of stock'
      if (emit)
        container.dispatchEvent(
          new CustomEvent('qty:change', {
            bubbles: true,
            detail: { value: 0 },
          }),
        )
      return
    } else {
      input.removeAttribute('disabled')
    }

    input.value = v
    container
      .querySelector('[data-qty-minus]')
      ?.toggleAttribute('disabled', v <= min)
    container
      .querySelector('[data-qty-plus]')
      ?.toggleAttribute('disabled', v >= max)

    if (v >= max && max !== Infinity) {
      status.textContent = `Maximum quantity ${max} reached`
    } else if (v <= min) {
      status.textContent = `Quantity ${v}, minimum ${min}`
    } else {
      status.textContent = `Quantity ${v}`
    }

    if (emit)
      container.dispatchEvent(
        new CustomEvent('qty:change', { bubbles: true, detail: { value: v } }),
      )
  }

  function syncAll(scope = document) {
    scope.querySelectorAll('[data-qty]').forEach((el) => sync(el, false))
  }

  document.addEventListener('click', (e) => {
    const minus = e.target.closest('[data-qty-minus]')
    const plus = e.target.closest('[data-qty-plus]')
    if (!minus && !plus) return
    const wrap = (minus || plus).closest('[data-qty]')
    const input = wrap?.querySelector('input[type="number"]')
    if (!input) return
    const step = parseFloat(wrap.dataset.step || input.step || '1') || 1
    input.step = step
    const before = input.value
    if (plus) input.stepUp()
    if (minus) input.stepDown()
    input.value = clampValue(input)
    if (input.value !== before)
      input.dispatchEvent(new Event('change', { bubbles: true }))
    sync(wrap, true)
  })

  document.addEventListener('input', (e) => {
    if (e.target.matches('[data-qty] input[type="number"]')) {
      sync(e.target.closest('[data-qty]'), true)
    }
  })

  // Listen for manual sync events (used to avoid loops during cart updates)
  document.addEventListener('qty:sync', (e) => {
    if (e.target.matches('[data-qty]')) {
      sync(e.target, false) // Don't emit change events during manual sync
    }
  })

  document.addEventListener('ui:hydrate', (e) => {
    const root = e.detail?.target || document
    syncAll(root)
  })
})()
